(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["orvena-double-heart-engraving"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('orvena-double-heart-engraving')) {
    customElements.define('orvena-double-heart-engraving', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const init = () => {
          const form = document.getElementById(this.dataset.form);
          const section = this.closest('.shopify-section');
          if (!form || !section) return;
          const panel = this.querySelector('[data-engraving-panel]');
          const words = [...this.querySelectorAll('[data-heart]')];
          const controls = [...this.querySelectorAll('input')];
          const keys = ['Left heart', 'Right heart', 'Font style'];
          const review = () => {
            words.forEach(input => {
              this.querySelector('[data-review="' + input.dataset.heart + '"]').textContent = input.value.trim() || this.dataset.plain;
              input.setCustomValidity('');
            });
            this.querySelector('[data-review="font"]').textContent = this.querySelector('input[type=radio]:checked')?.value || '';
          };
          const sync = () => {
            const picker = section.querySelector('variant-picker');
            const selected = picker?.querySelector('input[type=radio]:checked[value="Make It Yours"], select option:checked[value="Make It Yours"]');
            const enabled = picker ? Boolean(selected) : this.dataset.enabled === 'true';
            if (this.enabled && !enabled) words.forEach(input => { input.value = ''; });
            this.enabled = enabled;
            panel.hidden = !enabled;
            controls.forEach(input => { input.disabled = !enabled; });
            review();
          };
          this.addEventListener('input', review, {signal});
          section.addEventListener('change', sync, {signal});
          form.addEventListener('formdata', event => {
            if (!this.enabled) keys.forEach(key => event.formData.delete('properties[' + key + ']'));
            else words.forEach(input => {
              const value = input.value.trim();
              if (value) event.formData.set(input.name, value);
              else event.formData.delete(input.name);
            });
          }, {signal});
          form.addEventListener('submit', event => {
            sync();
            const expectedVariant = this.enabled ? this.dataset.engravedVariant : this.dataset.originalVariant;
            const variantInput = form.querySelector('[name="id"]');
            const waitMessage = section.querySelector('[data-orv-dh-wait]');
            if (waitMessage) waitMessage.hidden = true;
            if (variantInput && variantInput.value !== expectedVariant) {
              event.preventDefault();
              event.stopImmediatePropagation();
              if (waitMessage) waitMessage.hidden = false;
              return;
            }
            if (this.enabled && !words.some(input => input.value.trim())) {
              words[0].setCustomValidity(this.dataset.error);
              event.preventDefault();
              event.stopImmediatePropagation();
              words[0].reportValidity();
              words[0].focus();
            }
          }, {capture:true, signal});
          sync();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true, signal});
        else init();
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
